import React, {useEffect} from 'react';
import {withRouter} from 'next/router';
import {useTranslations} from 'next-intl';
import withNomenuLayout from 'layouts/nomenu';
import {pageMessagesProps} from 'helpers/i18n';
import {Grid, Row, Col} from '@/grid';
import Container from '@/container';
import SignupForm from '@/ui/signupform';
import {SectionFreeTrialBg} from '@/section';
import FormWrapper from '@/forms/form-wrapper';
import Head from 'next/head';
import FreeTrialWebMCP from 'components/webmcp/FreeTrialWebMCP';

// Content blocks
import Copyright from '@/footer/copyright';
import swordConfig from '../messages/en/swordConfig.json';
import shared from '../messages/en/shared.json';

const seoMetas = {
  title: 'Free Trial | Workable',
  description: 'Try Workable. Start a free trial today!',
  canonical: 'https://www.workable.com/free-trial'
};

const FreeTrialPage = props => {
  const FREE_TRIAL_DURATION = 15;
  const FREE_TRIAL_DURATION_EXTENDED = 30;
  const t = useTranslations('swordConfig');

  useEffect(() => {
    if (typeof window !== 'undefined' && window.swordConfig?.labels) {
      const urlParams = new URLSearchParams(window.location.search);
      const freeTrialDays =
        urlParams.get('aff') === 'trial30' ? FREE_TRIAL_DURATION_EXTENDED : FREE_TRIAL_DURATION;
      window.swordConfig.labels.userMessage = t('userMessage', {days: freeTrialDays});
    }
  }, [t]);

  return (
    <>
      <FreeTrialWebMCP />
      <Head>
        <link
          rel="preload"
          as="image"
          href="/static/images/free-trial/free-trial-bg.jpg"
          fetchpriority="high"
        />
      </Head>

      <SectionFreeTrialBg>
        <Container>
          <Grid fluid>
            <Row middle="md" center="xs">
              <Col xs={12} lg={8} xl={6}>
                <div data-testid="free-trial-form">
                  <FormWrapper>
                    <SignupForm />
                  </FormWrapper>
                </div>
              </Col>
            </Row>
          </Grid>
        </Container>
      </SectionFreeTrialBg>
      <Copyright linkColor="underlined" variant="orange50" />
    </>
  );
};

export default withNomenuLayout(withRouter(FreeTrialPage), {...seoMetas});

export const messagesForIntl = {shared, swordConfig};

export function getStaticProps() {
  return pageMessagesProps(messagesForIntl);
}
